export const FETCH_RENAME_THERMIT_UNIT_AREA_REQUEST = 'FETCH_RENAME_THERMIT_UNIT_AREA_REQUEST'
export const FETCH_RENAME_THERMIT_UNIT_AREA_SUCCESS = 'FETCH_RENAME_THERMIT_UNIT_AREA_SUCCESS'
export const FETCH_RENAME_THERMIT_UNIT_AREA_FALUIRE = 'FETCH_RENAME_THERMIT_UNIT_AREA_FALUIRE'
